import { AttributesEditorDataSource } from 'src/shared-app-portal/components/attributes-editor/attributesEditorDataSource';
import { EvaluationResponseAttributeWriteModel } from './evaluationResponseAttributeWriteModel';
import { MemberEvaluatee } from './memberEvaluatee';

export class MemberEvaluationDataSource {
  constructor(
    public evaluatee: MemberEvaluatee,
    public editorDataSource: AttributesEditorDataSource
  ) {}

  get isValid(): boolean {
    return this.editorDataSource.isValid;
  }

  public getWriteModel() {
    return this.editorDataSource.asAttributeWrites().map((attributeWriteModel) => {
      return new EvaluationResponseAttributeWriteModel(
        this.evaluatee.evaluationAssignmentId,
        attributeWriteModel
      );
    });
  }
}
